import React from "react"
import { graphql, StaticQuery } from "gatsby"
import Img from "gatsby-image"
import { useUIDSeed } from "react-uid"
import { Box } from "@rebass/grid/emotion"

import useAudioPlayer from "@hooks/useAudioPlayer"

import Bar from "./Bar"
import Pause from "./Pause"
import Play from "./Play"

import { Title, Wrapper } from "./styles"

const Player = ({ src, title }) => {
  const seed = useUIDSeed()
  const id = seed("audio")
  const {
    curTime,
    duration,
    setPlaying,
    setClickedTime,
  } = useAudioPlayer(id)
  return (
    <>
      <audio id={id}>
        <source src={src} />
        Your browser does not support the <code>audio</code> element.
      </audio>
      <Wrapper>
        <Box width={1 / 4}>
          <StaticQuery
            query={graphql`
              query {
                file(relativePath: { eq: "podcast-orange.png" }) {
                  childImageSharp {
                    fluid(maxWidth: 475) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            `}
            render={data => (
              <Img
                fluid={data.file.childImageSharp.fluid}
                style={{ marginBottom: 0 }}
              />
            )}
          />
        </Box>
        <Box width={3 / 4} px={4}>
          <Title>{title}</Title>
          <Bar
            curTime={curTime}
            duration={duration}
            onTimeUpdate={time => setClickedTime(time)}
          />
          <div>
            <Play onClick={() => setPlaying(true)} />
            <Pause onClick={() => setPlaying(false)} />
          </div>
        </Box>
      </Wrapper>
    </>
  )
}

export default Player
